const normalize = (url: string): string => {
  const base = url.startsWith('http://') || url.startsWith('https://') ? url : `http://${url}`;
  return base.replace(/\/$/, '');
};

export const statesUrl = (gatewayUrl: string): string =>
  `${normalize(gatewayUrl)}/relays.cgi`;

// Mijia-only: /relays.cgi (shared with switchbot/relay_board) only ever carries
// on/off power, so a mijia card's other real settings (fan speed, oscillation, ...)
// wouldn't show up until the next command. This is a real device read-back IR
// could never provide, so it's a separate endpoint rather than a shared-shape change.
export const settingsUrl = (gatewayUrl: string): string =>
  `${normalize(gatewayUrl)}/api/states`;

export const toggleUrl = (gatewayUrl: string, index: number): string =>
  `${normalize(gatewayUrl)}/relays.cgi?relay=${index + 1}`;

export const commandUrl = (
  gatewayUrl: string,
  index: number,
  cmd: string,
  params: Record<string, string> = {},
): string => {
  const qs = new URLSearchParams({ relay: String(index + 1), cmd, ...params });
  return `${normalize(gatewayUrl)}/api/command?${qs}`;
};

// Parses the board's HTML response.
// The hidden <p> contains a "Status: 0 1 0 1 ..." line with space-separated relay states.
// TODO: confirm toggle response format — currently only GET /relays.cgi is parsed.
export const parseStates = (html: string): (boolean | null)[] => {
  try {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const hidden = doc.querySelector('p[hidden]');
    if (!hidden) return [];
    const statusLine = hidden.textContent
      ?.split('\n')
      .map(l => l.trim())
      .find(l => l.startsWith('Status:'));
    if (!statusLine) return [];
    return statusLine
      .replace('Status:', '')
      .trim()
      .split(/\s+/)
      .map(v => v === '1');
  } catch {
    return [];
  }
};
